let sidebar = new FilterSidebar("#filterSidebar");

sidebar.$el.find(".FilterSidebar_reset").on("click", (event) => {
    event.preventDefault();
	filter.resetFilterForm();
	CorpusSchemeTrigger.reset();
});

$(".FilterMobileSwitcher").selectmenu({
    change: (event, ui) => {
        window.location.href = ui.item.value;
    },
});

$('.PanelBtn-filter').on('click', function () {
    $('.FilterPage_overlay').toggleClass('FilterPage_overlay-active');
    $('body').toggleClass('scroll-lock');
    sidebar.toggle();
})

$('.FilterPage_overlay, .FilterSidebar_close, .FilterForm_btn-search').on('click', function () {
    $('.FilterPage_overlay').removeClass('FilterPage_overlay-active');
    $('body').toggleClass('scroll-lock');
    sidebar.toggle();
})

$(".FilterMobileSwitcher").selectmenu({
	change: (event, ui) => {
		window.location.href = ui.item.value;
	}
});

//ranges dinamic

function updateRanges(ranges) {
	$.each(ranges, (key, val) => {
			let slider = document.getElementById('range-' + key);
			let $slider = $(slider);
			let $inputs = $slider.find('input');
			let $key = key;

			let $ranges = filter.getRangeSliders();

			$.each($ranges, function (key, value) {
					if (value.$track.parent().attr('id') == ('range-' + $key)) {
							console.log(value.$track.parent())
							value.$track.parent().data('dinamicrange', 'true');
							value.renderValuesToCounterEl([parseInt(val[0]), parseInt(val[1])]);
							value.$track.slider('values', [parseInt(val[0]), parseInt(val[1])]);
							value.$track.parent().data('dinamicrange', 'false');
					}
			})
	});

	
};

let sliderID;
let checkboxID;
let resetChecksInf = false;

$('.FilterForm').on('change', 'input', function (e) {
	let $target = $(e.target);
	let name  = $target.attr('name');
	resetChecksInf = false;

	if (name == 'bedrooms[]' || name == 'corpus[]' || name == 'quarters[]' || name == 'promo' || name == 'finish') {
		resetChecksInf = true;
	}
	if ($target.is(':checkbox')) {
			checkboxID = $target.attr('name');
			
	} else {
			checkboxID = undefined;
	}

	if ($target.closest('.RangeSlider').length) {
			sliderID = $target.closest('.RangeSlider').attr('id');
	} else {
			sliderID = undefined;
	}
});



$('.RangeSlider').on('change', (e) => {

	$('.RangeSlider').removeClass('_last');
	$(e.currentTarget).addClass('_last');
});



let flatsList = new FlatsList(".Tbl-flatParams", {
	renderElement: "#filterResultsContainer"
});

const LIMIT = 12;

let offset = 0;

let $getMoreFlatsBtn = $("#getMoreFlats");

let updateGetMoreBtn = response => {
	let flatsRemains = response.total - offset - LIMIT;
	let loadNextTimeCount = LIMIT;
	if (flatsRemains < LIMIT) {
		loadNextTimeCount = flatsRemains;
	}

	if (loadNextTimeCount <= 0) {
		$getMoreFlatsBtn.hide();
	} else {
		$getMoreFlatsBtn
			.show()
			.find("#extraFlatsCounter")
			.html(loadNextTimeCount);
	}
};

let filter = new FilterForm("#filterForm", {
	submitHandler: $filterForm => {
		// window.pagePreloader.show();
		offset = 0;
		let dataToSend = $filterForm.serializeObject();
		let lastSlider = $('.RangeSlider').filter('._last').attr('id');
		$.extend(true, dataToSend, {
			action: "get_flats",
			limit: LIMIT,
			offset: 0,
			current_control: (typeof sliderID != 'undefined') ? sliderID : '',
			last_control: (typeof lastSlider != 'undefined') ? lastSlider : '',
			// current_checkbox: (typeof checkboxID != 'undefined') ? checkboxID : ''
		});

		let dataSendValues = ['floor_from', 'floor_to', 'price_from', 'price_to', 'area_from', 'area_to'];

		if (resetChecksInf) {
				let lastSliderType = lastSlider == undefined ? "undefined" : lastSlider.replace("range-", "");
				$(dataSendValues).each((i, e) => {
					if (e.indexOf(lastSliderType) != 0) {
						delete dataToSend[e];
					}
				})
		}

		$.ajax({
			url: $filterForm.attr("action") || $filterForm.data("action"),
			dataType: "json",
			method: "GET",
			data: dataToSend,
			beforeSend: () => {
				$("body").addClass("_loading");
			},
		})
			.done(response => {
				setTimeout(() => {
					$("body").removeClass("_loading");
				}, 1000);

				updateRanges(response.ranges);
				flatsList.render({ flats: response.flats, promos: response.promos });
				updateGetMoreBtn(response);
			})
			.fail(() => {
				alert("Не удалось получить данные с сервера! Попробуйте позже.");
			})
			.always(function() {
				// window.pagePreloader.hide();
			});
	}
});

$getMoreFlatsBtn.on("click", event => {
	event.preventDefault();

	let dataToSend = filter.$filterForm.serializeObject();

	$.extend(true, dataToSend, {
		action: "get_flats",
		limit: LIMIT,
		offset: offset + LIMIT
	});

	$.ajax({
		url: filter.$filterForm.attr("action") || filter.$filterForm.data("action"),
		dataType: "json",
		method: "GET",
		data: dataToSend
	})
		.done(response => {
			offset += LIMIT;
			flatsList.append({ flats: response.flats, promos: response.promos });
			updateGetMoreBtn(response);
		})
		.fail(() => {
			alert("Не удалось получить данные с сервера! Попробуйте позже.");
		});
});

$('.FilterForm_label-accord').on('click', function () {
	$(this).toggleClass('FilterForm_label-accordActive');
	$(this).siblings('.FilterForm_chksOtherGroup').slideToggle(300);
});

$("#filterResult").on('click', function (event) {
    const $target = $(event.target);

    if ($target.hasClass('NoPlansFound_reset')) {
        event.preventDefault();

        $('.FilterSidebar_reset').trigger('click');
    }
});

let $sortInp = $("#sortInp");
let $sortOrderInp = $("#sortOrderInp");

let tbl = new Tbl(".Tbl-flatParams", {
	onSortChange: (sortName, direction) => {
		$sortInp.val(sortName);
		$sortOrderInp.val(direction).trigger("change");
	}
});


let popupTpl = _.template(
    `<div class="infoTooltip infoTooltip-flatParams" style="width: 222px; pointer-event:none;">
        <img class="infoTooltip_flatParamsImg" src="<%= img %>"/>
    </div>`.replace(/\s{2,}/g, "")
);

let setupSectionHoverBehaviour = () => {

    let $scheme = $(".FilterPage_flatParamsList");

    if ($scheme.length) {
        $scheme.tooltip({
            items: "[data-thumb]",
            // track: true,
            position: { my: "center", at: "center" },
            hide: { duration: 0 },
            show: { duration: 0 },
            content: function() {
                let $el = $(this);
                let params = $el.data("thumb");
                let dataToRender = {
                    img: null
                };

                _.assignIn(dataToRender, params);
                return popupTpl(dataToRender, params);
            }
        });
    }
};

$(window).on("load", () => {
    setupSectionHoverBehaviour();
});

$('.TurnButton, .FilterPage_flatParamsTopLink-navigate').on('click', function (e) {
    $('.TurnButton').toggleClass('TurnButton-on');

    e.preventDefault();
         
         var 
            href = $(this).attr('href'),
            timeout = 700;
            
         setTimeout(function() {
            location.href = href;
         }, timeout);
});

let isRadioCorpus = false;
let CorpusSchemeTrigger = {
	init: function() {
		const $item = $(".HousesScheme_bld");
		const $checkbox = $(".CustomCheckbox").find('[name="corpus[]"]');

		$item.on("click", function(e) {
			const $data = $(e.currentTarget).data("triggercorpus");
			e.preventDefault()
			if (isRadioCorpus) {
				$item.removeClass("HousesScheme_bld-active");
			}
			$checkbox.each((i, e) => {
				if ($(e).data(`persist-id`) === $data) {
					$(e).trigger("click");

					if ($(e).is(":checked")) {
						$(e.currentTarget).addClass("HousesScheme_bld-active");
					} else {
						$(e.currentTarget).removeClass("HousesScheme_bld-active");
					}
				}
			})
		});

		$checkbox.on("change", function() {
			const data = $(this).data("persist-id");

			if (isRadioCorpus) {
				$item.removeClass("HousesScheme_bld-active");
			}
			
			if ($(this).is(":checked")) {
				$(`[data-triggercorpus=${data}]`).addClass("HousesScheme_bld-active");
			} else {
				$(`[data-triggercorpus=${data}]`).removeClass("HousesScheme_bld-active");
			}
		});

		$(window).on("load", function() {

			if (isRadioCorpus) {
				$checkbox.find('[data-persist-id = "corpus_1"]').trigger('click');
			}

			$checkbox.each((i, e) => {
				if ($(e).is(":checked")) {
					const data = $(e).data("persist-id");

					$(`[data-triggercorpus=${data}]`).addClass("HousesScheme_bld-active");
				}
			});
		});
	},

	reset: function() {
		const $item = $(".HousesScheme_bld");
		const $checkbox = $(".CustomCheckbox").find('[name="corpus[]"]');

		if (isRadioCorpus) {
			$checkbox.find('[data-persist-id = "corpus_1"]').trigger('click');

			$checkbox.each((i, e) => {
				if ($(e).is(":checked")) {
					const data = $(e).data("persist-id");
					$item.removeClass("HousesScheme_bld-active");
					$(`[data-triggercorpus=${data}]`).addClass("HousesScheme_bld-active");
				}
			});
		}

		if (!isRadioCorpus) {
			$item.removeClass("HousesScheme_bld-active");
		}
	}
};

CorpusSchemeTrigger.init();